import React from 'react'
import { AboutInnerBanner } from '../../Components/Common/InnerBanner/AboutInnerBanner';
import AboutInnBanContent from '../../Components/Common/InnerBanner/AboutInnBanContent';
import RightHandSide from '../../Components/Common/Services/RightHandSide';
import TopContent from '../../Components/Common/Services/TopContent';
import TopContentTxt from '../../Components/Common/Services/TopContentTxt';
import DbDevide from '../../Components/Common/Services/DbDevide';
import DbDevideData from '../../Components/Common/Services/DbDevideData';
import DbListData from '../../Components/Common/Services/DbListData';
import DbList from '../../Components/Common/Services/DbList';
import Transition from '../../Components/Transition';
import { Helmet } from 'react-helmet';

const WomenHealthCare = () => {
  const {image, heading, pageName} = AboutInnBanContent.WomenHealthCare;
  const {banner, head, pOne, pTwo, highligth} = TopContentTxt.WomenHealthCare;
  const {dbHeading, dbImg, DBdata} = DbDevideData.WomenHealthCare;
  const {dlHeading, Dldata} = DbListData.WomenHealthCare

  return (
    <>
    <Helmet>
      <title>Best Women's Health Care: Total Wellness & Disease Prevention</title>
      <meta name='description' content="Best women's health care solutions addressing cancer, infertility, menstrual issues, and lifestyle impacts on wellness." />
      <meta name='keywords' content='Polycystic ovaries, Precancerous , ivf fertility , best ivf fertility ' />
      <link rel="canonical" href="https://www.acmefertility.com/WomenHealthCare" />
      <meta name="robots" content="Index, follow " />
    </Helmet>

    <AboutInnerBanner image={image} heading={heading} pageName={pageName} />
    <div className="blog-details-area pt-100 pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <TopContent banner={banner} head={head} pOne={pOne} pTwo={pTwo} highligth={highligth} />

            <DbDevide dbHeading={dbHeading} dbImg={dbImg} DBdata={DBdata} />

            <DbList dlHeading={dlHeading} Dldata={Dldata} />
          </div>
          <div className="col-lg-4">
            <RightHandSide />
        </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Transition(WomenHealthCare) 